import React from "react";
import "./Footer.css";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedinIn,
  FaGithub,
} from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="mt-">
        <h3 className="text-black text-center">
          All rights reserved by{" "}
          <span style={{ color: "white" }}>Zahidul Islam</span>
        </h3>
        <hr className="break mt-3 mb-3" />
        <h6 className="text-white text-center">Stay connected</h6>
      </div>

      <div className="social-icon-block d-flex justify-content-center align-items-center">
        <span className="icon-container">
          {" "}
          <a href="https://www.facebook.com/profile.php?id=100042487011960">
            <li>
              <FaFacebook className="icon" />
            </li>
          </a>
        </span>
        <span className="icon-container">
          <a href="https://www.instagram.com/z.islam144/">
            <li>
              <FaInstagram className="icon" />
            </li>
          </a>
        </span>

        <span className="icon-container">
          <a href="https://www.linkedin.com/in/zahidul-islam-5432b5189/">
            <li>
              <FaLinkedinIn className="icon" />
            </li>
          </a>
        </span>
        <span className="icon-container">
          <a href="https://github.com/zahidul-islam-144">
            <li>
              <FaGithub className="icon" />
            </li>
          </a>
        </span>
      </div>
    </div>
  );
};

export default Footer;
